import React from 'react';

function Home() {
  return <h1>No page to display.</h1>;
}

export default Home;